import { useAuth } from '@/shared/auth/useAuth'
import { isMaskedValue } from './contactDraft'
import type { AttachmentValue } from './AttachmentInput'
import type { InstallerValue } from './InstallerInput'
import type { LocationValue } from './LocationPicker'
import type { CustomerType, DeviceOwnership, SubscriberProfile, SubscriberProfileDraft } from './profileApi'
import { normalizePhone } from './subscriberApi'

export interface ProfileFieldValues {
  firstName?: string
  fatherName?: string
  lastName?: string
  deviceTypeId?: string
  deviceOwnership?: DeviceOwnership
  customerType?: CustomerType
  whatsapp?: string
  photo?: AttachmentValue | null
  contract?: AttachmentValue | null
  installer?: InstallerValue | null
  location?: LocationValue | null
}

const KABUL: LocationValue = { lat: 34.5553, lng: 69.2075 }
const TASHKENT: LocationValue = { lat: 41.3111, lng: 69.2797 }

export function useMapFallback(): LocationValue {
  const { user } = useAuth()
  const currency = user?.currency
  return currency === 'AFN' ? KABUL : TASHKENT
}

export function profileFormValues(p: SubscriberProfile | null | undefined): ProfileFieldValues {
  if (!p) return {}
  return {
    firstName: p.firstName ?? undefined,
    fatherName: p.fatherName ?? undefined,
    lastName: p.lastName ?? undefined,
    deviceTypeId: p.deviceTypeId ?? undefined,
    deviceOwnership: p.deviceOwnership ?? undefined,
    customerType: p.customerType ?? undefined,
    whatsapp: undefined,
    photo: null,
    contract: null,
    installer: p.installedByName
      ? { personId: p.installedByPersonId ?? null, name: p.installedByName }
      : null,
    location:
      p.latitude != null && p.longitude != null ? { lat: p.latitude, lng: p.longitude } : null,
  }
}

function text(v: string | undefined): string | null {
  const s = v?.trim()
  return s ? s : null
}

/** Tahrirlashda bo'sh maydon yuborilmaydi — server eski qiymatni saqlaydi. */
export function profileDraft(v: ProfileFieldValues): SubscriberProfileDraft {
  const whatsapp = normalizePhone(v.whatsapp)
  return {
    firstName: text(v.firstName),
    fatherName: text(v.fatherName),
    lastName: text(v.lastName),
    deviceTypeId: v.deviceTypeId ?? null,
    deviceOwnership: v.deviceOwnership ?? null,
    customerType: v.customerType ?? null,
    whatsapp: whatsapp && !isMaskedValue(whatsapp) ? whatsapp : null,
    photoFileId: v.photo?.id ?? null,
    contractFileId: v.contract?.id ?? null,
    installedByPersonId: v.installer?.personId ?? null,
    installedByName: text(v.installer?.name),
    latitude: v.location?.lat ?? null,
    longitude: v.location?.lng ?? null,
  }
}
